import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const Footer = () => {
    const [siteSettings, setSiteSettings] = useState({
        companyName: "VishwaVoyagerz",
        address: "123 Travel Street, Adventure City, AC 12345",
        phone: "+1 (555) 123-4567",
        email: "info@vishwavoyagerz.com",
        facebookUrl: "#",
        twitterUrl: "#",
        instagramUrl: "#",
        youtubeUrl: "#"
    });

    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const response = await axios.get('/api/site-settings');
                setSiteSettings(response.data);
            } catch (error) {
                console.error("Error fetching site settings:", error);
            }
        };
        fetchSettings();
    }, []);

    return (
        <footer className="bg-gray-900 text-gray-300 py-16" id="contact">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
                    <div>
                        <div className="flex items-center space-x-3 mb-6">
                            <img src="https://uxmagic.blob.core.windows.net/components/uploads/Untitled%20design%20(2)-1765043517183-a2blnuh7e8j.png" alt="VishwaVoyagerz" className="h-12 w-auto" />
                            <div className="flex flex-col">
                                <span className="text-xl font-bold bg-gradient-to-r from-brand-green via-brand-teal to-brand-cyan bg-clip-text text-transparent">{siteSettings.companyName}</span>
                                <span className="text-xs text-brand-cyan">Tours and Travels</span>
                            </div>
                        </div>
                        <p className="text-gray-400 mb-6">Your trusted partner for unforgettable travel experiences around the world. Explore, discover, and create memories that last a lifetime.</p>
                        <div className="flex space-x-4">
                            <a href={siteSettings.facebookUrl} target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-brand-teal transition transform hover:scale-110 hover:rotate-12">
                                <i className="fab fa-facebook-f"></i>
                            </a>
                            <a href={siteSettings.twitterUrl} target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-brand-cyan transition transform hover:scale-110 hover:rotate-12">
                                <i className="fab fa-twitter"></i>
                            </a>
                            <a href={siteSettings.instagramUrl} target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-brand-green transition transform hover:scale-110 hover:rotate-12">
                                <i className="fab fa-instagram"></i>
                            </a>
                            <a href={siteSettings.youtubeUrl} target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-red-600 transition transform hover:scale-110 hover:rotate-12">
                                <i className="fab fa-youtube"></i>
                            </a>
                        </div>
                    </div>

                    <div>
                        <h3 className="text-white text-xl font-bold mb-6">Quick Links</h3>
                        <ul className="space-y-3">
                            <li><Link to="/about" className="hover:text-brand-teal transition transform hover:translate-x-2 inline-block">About Us</Link></li>
                            <li><Link to="/#packages" className="hover:text-brand-teal transition transform hover:translate-x-2 inline-block">Tour Packages</Link></li>
                            <li><Link to="/tours" className="hover:text-brand-teal transition transform hover:translate-x-2 inline-block">All Tours</Link></li>
                            <li><Link to="/categories" className="hover:text-brand-teal transition transform hover:translate-x-2 inline-block">Tour Types</Link></li>
                            <li><Link to="/contact" className="hover:text-brand-teal transition transform hover:translate-x-2 inline-block">Contact Us</Link></li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="text-white text-xl font-bold mb-6">Support</h3>
                        <ul className="space-y-3">
                            <li><a href="/" className="hover:text-brand-teal transition transform hover:translate-x-2 inline-block">Help Center</a></li>
                            <li><a href="/" className="hover:text-brand-teal transition transform hover:translate-x-2 inline-block">Booking Policy</a></li>
                            <li><a href="/" className="hover:text-brand-teal transition transform hover:translate-x-2 inline-block">Privacy Policy</a></li>
                            <li><a href="/" className="hover:text-brand-teal transition transform hover:translate-x-2 inline-block">Terms & Conditions</a></li>
                            <li><a href="/" className="hover:text-brand-teal transition transform hover:translate-x-2 inline-block">FAQs</a></li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="text-white text-xl font-bold mb-6">Contact Info</h3>
                        <ul className="space-y-4">
                            <li className="flex items-start transform hover:translate-x-2 transition">
                                <i className="fas fa-map-marker-alt text-brand-teal mt-1 mr-3"></i>
                                <span>{siteSettings.address}</span>
                            </li>
                            <li className="flex items-center transform hover:translate-x-2 transition">
                                <i className="fas fa-phone text-brand-teal mr-3"></i>
                                <span>{siteSettings.phone}</span>
                            </li>
                            <li className="flex items-center transform hover:translate-x-2 transition">
                                <i className="fas fa-envelope text-brand-teal mr-3"></i>
                                <span>{siteSettings.email}</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="border-t border-gray-800 pt-8 text-center">
                    <p className="text-gray-400">© {new Date().getFullYear()} {siteSettings.companyName}. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
